var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewSalesOrderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#584b4b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#584b4b;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.73,
    y1: 11.05,
    x2: 10.09,
    y2: 11.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.73,
    y1: 14.86,
    x2: 10.09,
    y2: 14.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.73,
    y1: 18.68,
    x2: 10.09,
    y2: 18.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.59 6.27 20.59 22.5 3.41 22.5 3.41 1.5 15.82 1.5 20.59 6.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.59 6.27 20.59 7.23 14.86 7.23 14.86 1.5 15.82 1.5 20.59 6.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.27,
    y1: 11.05,
    x2: 8.18,
    y2: 11.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.27,
    y1: 14.86,
    x2: 8.18,
    y2: 14.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.27,
    y1: 18.68,
    x2: 8.18,
    y2: 18.68
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSalesOrderList);
export default __webpack_public_path__ + "static/media/view_sales_order_list.2bea49521da94e2ff6afd2a69f7777b8.svg";
export { ForwardRef as ReactComponent };